import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import ApiRequest from 'core/api/request';
import ClickOutsideToDismiss from 'core/components/ClickOutsideToDismiss';
import FullstoryUtil from 'fullstory_util';

import { ResponsiveCheck } from 'core/providers/Responsive';

import {
	ShopBagContainer,
	ShopBagIcon,
	BagCounter,
} from './styles';
import CartList from './CartList';

class ShopBag extends React.Component {
	state = {
		open: false,
		carts: [],
		loading: true,
		prev: null,
		next: null,
		count: this.props.cartCount || 0,
	}

	componentDidMount() {
		const cartCount = Cookies.get('cartCount');
		if (cartCount) {
			this.setState({ count: cartCount });
		}

		this.query();
	}

	query(params = null) {
		params = params || { limit: 20, page: 1 };
		params['live_only'] = true;
		params['skip_empty'] = true;

		ApiRequest.get('/carts/', params)
			.then(({ results, prev, next }) => {
				const filteredCarts = results.filter((cart) => !!cart?.listing?.slug);
				Cookies.set('cartCount', filteredCarts.length || '', { expires: 90 });
				this.setState({ carts: filteredCarts, loading: false, prev: prev, next: next, count: filteredCarts.length });
			})
			.catch(({ errors }) => {
				console.log(errors);
			});
	}

	onBagClick = e => {
		this.toggleOpen();
	};

	toggleOpen = () => {
		const { open } = this.state;
		this.setState({ open: !open });
		const { toggleBottomEnabled } = this.props;
		if (toggleBottomEnabled) {
			toggleBottomEnabled(open);
		}

		FullstoryUtil.sendEvent('cartOpened');
	};

	close = () => {
		if (this.state.open) this.toggleOpen();
	};

	removeItem = cartId => {
		const carts = this.state.carts.filter(cart => cart.id !== cartId);
		const newCount = this.state.count - 1;
		this.setState({ count: newCount, carts: carts });
		Cookies.set('cartCount', newCount || '', { expires: 90 });
	};

	render() {
		return (
			<ResponsiveCheck>
				{({ isDesktop }) => (
					<ClickOutsideToDismiss onClose={this.close} active={this.state.open}>
						<Fragment>
							<ShopBagContainer onClick={this.onBagClick} aria-label="Toggle Shopping Cart">
								<ShopBagIcon />
								{this.state.count ? <BagCounter>{isDesktop ? this.state.count : ''}</BagCounter> : null}
							</ShopBagContainer>
							<CartList open={this.state.open} onClose={this.close} removeItem={this.removeItem} carts={this.state.carts} />
						</Fragment>
					</ClickOutsideToDismiss>
				)}
			</ResponsiveCheck>
		);
	}
}

ShopBag.propTypes = {
	cartCount: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	toggleBottomEnabled: PropTypes.func,
};

export default ShopBag;
